import { MINUTES_PER_DAY } from 'utils/date/minutesPerDay';

/** `days` after a "YYYY-MM-DD" date, as the same shape; negative walks backwards. */
const addDays = (date: string, days: number): string =>
  new Date(Date.parse(`${date}T00:00:00Z`) + days * MINUTES_PER_DAY * 60_000)
    .toISOString()
    .slice(0, 10);

export default addDays;
